import { Paper, Typography, useTheme } from "@mui/material";
import { formatSeconds } from "../../store/formatUtil";
import { alpha } from "@mui/material";

export const DAWTimeDisplay = ({ currentTime, duration, mode }) => {
  const theme = useTheme();
  return (
    <Paper
      sx={{
        backgroundColor: mode === "dark" && alpha(theme.palette.grey[900], 0.9),
        color: mode === "dark" && theme.palette.grey[100],
        display: "flex",
        alignItems: "center",
        gap: 2,
        justifyContent: "center",
        height: 22,
        zIndex: 2,
      }}
    >
      <Typography lineHeight={1} variant="overline">
        {formatSeconds(currentTime.toFixed(3))}
      </Typography>
      <Typography lineHeight={1} variant="overline">
        |
      </Typography>
      <Typography lineHeight={1} variant="overline">
        {formatSeconds(duration.toFixed(3))}
      </Typography>
    </Paper>
  );
};
